import { REACT_APP_RECAPTCHA_SITE_KEY } from 'constants/app-env';

export const HELP_CHAT_INTERCOM_ID = 'umai_help_chat_link';
export const HELP_CENTER_URL = 'https://help.letsumai.com/en/';
export const CHANNELS = {
  loyaltyChannel: 'PartnerCable::LoyaltyChannel',
  userChannel: 'PartnerCable::UserChannel',
};

export const UMAI_WELCOME_URL = 'https://www.umai.io/en/welcome';
export const RECAPTCHA_SCRIPT_URL = `https://www.google.com/recaptcha/api.js?render=${REACT_APP_RECAPTCHA_SITE_KEY}`;
